var _dec,
  _class,
  _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/mobile/index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { fetchMobilePage } from 'soapbox/actions/mobile';
import { getSettings } from 'soapbox/actions/settings';
import { getSoapboxConfig } from 'soapbox/actions/soapbox';
import { languages } from '../preferences';
const mapStateToProps = state => ({
  locale: getSettings(state).get('locale'),
  mobilePages: getSoapboxConfig(state).get('mobilePages')
});
let MobilePage = (_dec = connect(mapStateToProps), _dec(_class = injectIntl(_class = class MobilePage extends ImmutablePureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      pageHtml: '',
      locale: this.props.locale
    });
    _defineProperty(this, "loadPageHtml", () => {
      const {
        dispatch,
        match,
        mobilePages
      } = this.props;
      const {
        locale
      } = this.state;
      const {
        slug
      } = match.params;
      const page = mobilePages.get(slug || 'mobile');
      const fetchLocale = page && locale !== page.get('default') && page.get('locales').includes(locale);
      dispatch(fetchMobilePage(slug, fetchLocale && locale)).then(html => {
        this.setState({
          pageHtml: html
        });
      }).catch(error => {
        // TODO: Better error handling. 404 page?
        this.setState({
          pageHtml: '<h1>Page not found</h1>'
        });
      });
    });
    _defineProperty(this, "setLocale", locale => () => {
      this.setState({
        locale
      });
    });
  }
  componentDidMount() {
    this.loadPageHtml();
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      locale,
      match,
      mobilePages
    } = this.props;
    const {
      locale: prevLocale,
      mobilePages: prevMobilePages
    } = prevProps;
    const {
      locale: stateLocale
    } = this.state;
    const {
      locale: prevStateLocale
    } = prevState;
    const {
      slug
    } = match.params;
    const {
      slug: prevSlug
    } = prevProps.match.params;
    if (locale !== prevLocale) this.setState({
      locale
    });
    if (slug !== prevSlug || stateLocale !== prevStateLocale || !prevMobilePages.get(slug || 'mobile') && mobilePages.get(slug || 'mobile')) this.loadPageHtml();
  }
  render() {
    const {
      match,
      mobilePages
    } = this.props;
    const {
      slug
    } = match.params;
    const page = mobilePages.get(slug || 'mobile');
    const defaultLocale = page && page.get('default');
    const alsoAvailable = page && /*#__PURE__*/React.createElement("div", {
      className: "rich-formatting also-available",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "mobile.also_available",
      defaultMessage: "Available in:",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 9
      }
    }), ' ', /*#__PURE__*/React.createElement("ul", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("li", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: this.setLocale(defaultLocale),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 13
      }
    }, languages[defaultLocale] || defaultLocale)), page.get('locales').map(locale => /*#__PURE__*/React.createElement("li", {
      key: locale,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: this.setLocale(locale),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 17
      }
    }, languages[locale] || locale)))));
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.state.pageHtml
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 9
      }
    }), alsoAvailable);
  }
}) || _class) || _class);
export default MobilePage;